import { render, staticRenderFns } from "./tabSponsorMedia.vue?vue&type=template&id=61f0d619&"
import script from "./tabSponsorMedia.vue?vue&type=script&lang=js&"
export * from "./tabSponsorMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports